import { cancelOrder, isOpen, type Order } from '../api/trading';

/** Plan 074: a sell at 1¢ takes whatever bids exist, best first (plan 072). 1¢ is on every Kalshi price grid. */
export const ANY_BID = '0.01';

/** Your own resting sells on a contract count against what you hold, so they go first when you want out. */
export async function clearRestingSells(orders: Order[], ticker: string, side: string) {
  await Promise.all(orders.filter(o => isOpen(o) && o.action === 'sell' && o.ticker === ticker && o.side === side).map(o => cancelOrder(o.id)));
}
